import { render, staticRenderFns } from "./ViewVacationsBalance.vue?vue&type=template&id=48ab2cd0&scoped=true"
import script from "./ViewVacationsBalance.vue?vue&type=script&lang=js"
export * from "./ViewVacationsBalance.vue?vue&type=script&lang=js"
import style0 from "./ViewVacationsBalance.vue?vue&type=style&index=0&id=48ab2cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab2cd0",
  null
  
)

export default component.exports